import { Component } from '@angular/core';
import {Toastr, ToastrService} from '../../services/toast/toastr.service';
import {SharedComponentsModule} from '../../shared-components/shared-components.module';
import {NgbToastModule} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'bor-toastr',
  imports: [NgbToastModule, SharedComponentsModule],
  templateUrl: './toastr.component.html',
  styleUrl: './toastr.component.scss',
	host: { class: 'toast-container position-fixed top-0 end-0 p-3', style: 'z-index: 1200' },
})
export class ToastrComponent {

  constructor(public toastr:ToastrService){}

  getClassname(toast:Toastr){
    let className = `toastr rounded-0 ${(toast as any)?.classname || ''}`;

    switch (toast.type) {
      case 'DANGER':
        className = `${className} danger`;
        break;
      case 'SUCCESS':
        className = `${className} success`;
        break;
      case 'INFO':
        className = `${className} info`;
        break;
      case 'WARNING':
        className = `${className} warning`;
        break;
      default:
        break;
    }

    return className;
  }
}
